import { mapActions, mapGetters, mapState } from 'vuex';
import modal from '@/components/generics/modal/modal.vue';
import genericPopup from '@/components/generics/modal/layouts/generic.vue';
import genericSmallPopup from '@/components/generics/modal/layouts/generic-small.vue';
import accountLogin from '@/components/account/account-login/account-login.vue';
import accountLoginFooter from '@/components/account/account-login/footer/footer.vue';
import accountForgotten from '@/components/account/account-forgotten/account-forgotten.vue';
import accountForgottenFooter from '@/components/account/account-forgotten/footer/footer.vue';
import accountRegister from '@/components/account/account-register/account-register.vue';
import accountRegisterFooter from '@/components/account/account-register/footer/footer.vue';
import accountRegisterExternal from '@/components/account/account-register-external/account-register-external.vue';
import accountDetailsVerify from '@/components/account/account-details/modal/account-details-verify.vue';
import accountUploadId from '@/components/account/account-upload-id/account-upload-id.vue';
import accountUploadDocument from '@/components/account/account-upload-document/account-upload-document.vue';
import accountDetailsUpdateModal from '@/components/account/account-details/modal/account-details-update-modal.vue';
import accountUpdateImage from '@/components/account/account-update-image/account-update-image.vue';
import addFundsCombined from '@/components/wallet/add-funds-combined/add-funds-combined.vue';
import addFundsCombinedFooter from '@/components/wallet/add-funds-combined/footer/footer.vue';
import deposited from '@/components/wallet/deposited/deposited.vue';
import potentialPayouts from '@/components/potential-payouts/potential-payouts.vue';
import smallModal from '@/components/generics/modal/small/small.vue';
import exportHistory from '@/components/export-history/export-history.vue';
import purchaseModal from '@/components/purchase/purchase-modal/purchase-modal.vue';
import insightModal from '@/components/insight/insight-modal/insight-modal.vue';
import research from '@/components/research/research.vue';
import taxInfoNotification from '@/components/tax-info-notification/tax-info-notification.vue';
import twitterTimeline from '@/components/twitter/twitter-timeline/twitter-timeline.vue';
import newsFeed from '@/components/home/home-old/news-feed/news-feed.vue';
import attachToHome from '@/components/attach-to-home/attach-to-home.vue';
import offersIndicatorPopup from '@/components/offers-indicator-popup/offers-indicator-popup.vue';
import marketContractsStatsPopup from '@/components/market/market-contracts-stats-popup/market-contracts-stats-popup.vue';
import accountResetPassword from '@/components/account/account-reset-password/account-reset-password.vue';
import orientationInfo from '@/components/orientation-info/orientation-info.vue';
import accountBadgesList from '@/components/account/account-badges-list/account-badges-list.vue';
import userProfileOverview from '@/components/social/user-profile-overview/user-profile-overview.vue';
import userProfileOverviewHeader from '@/components/social/user-profile-overview-header/user-profile-overview-header.vue';
import userReport from '@/components/social/user-report/user-report.vue';
import leaderboardsTrophyPyramid from '@/components/leaderboards/leaderboards-trophy-pyramid/leaderboards-trophy-pyramid.vue';
import messagingJourneyInfo from '@/components/messaging-journey-info/messaging-journey-info.vue';
import coinbaseProcessOverview from '@/components/wallet/coinbase-process-overview/coinbase-process-overview.vue';
import affiliationsPopup from '@/components/profile/affiliations-popup/affiliations-popup.vue';
import announcement from '@/components/announcement/announcement.vue';
import accountAlreadyExists
  from '@/components/account/account-already-exists/account-already-exists.vue';
import accountAlreadyExistsFooter from '@/components/account/account-already-exists/footer/footer.vue';
import accountEnableClassicPredictit
  from '@/components/account/account-enable-classic-predictit/account-enable-classic-predictit.vue';
import accountEnableClassicPredictitFooter
  from '@/components/account/account-enable-classic-predictit/footer/footer.vue';

export const MODALS = {
  LOGIN: 'login',
  FORGOTTEN: 'forgotten',
  RESET_PASSWORD: 'reset-password',
  REGISTER: 'register',
  REGISTER_EXTERNAL: 'register-external',
  ACCOUNT_VERIFY: 'account-verify',
  UPLOAD_ID: 'upload-id',
  TAX_INFO: 'tax-info',
  ATTACH_TO_HOME: 'attach-to-home',
  ACCOUNT_DETAIL_UPDATE: 'account-detail-update',
  ACCOUNT_DETAIL_PASSWORD: 'account-detail-password',
  ACCOUNT_DETAIL_PASSWORD_SET: 'account-detail-password-set',
  ACCOUNT_ADDRESS_UPDATE: 'account-address-update',
  ADD_FUNDS: 'add-funds',
  PAYMENT_SUCCESS: 'payment-success',
  PAYMENT_ERROR: 'payment-error',
  POTENTIAL_PAYOUTS: 'potential-payouts',
  MARKET_CONTRACT_STATS: 'market-contracts-stats',
  RESEARCH: 'research',
  TWITTER: 'twitter',
  NEWS_FEED: 'news-feed',
  PURCHASE: 'purchase-modal',
  INSIGHT: 'insight-modal',
  GENERIC: 'generic',
  EXPORT_TRADE_HISTORY: 'export-trade-history',
  EXPORT_TRANSACTION_HISTORY: 'export-transaction-history',
  COINBASE: 'coinbase',
  SMALL_CVV: 'cvv',
  SMALL_SWIFT: 'swift',
  SMALL_ROUTING_NUMBER: 'routing-number',
  SMALL_EDIT_IMAGE: 'edit-image',
  SMALL_MARKET_RULES: 'market-rules',
  SMALL_GENERIC: 'generic-small',
  SMALL_USERNAME: 'username',
  SMALL_TRADE_INFO: 'account-trade-info',
  SMALL_OFFERS_INDICATOR: 'offers-indicator',
  SMALL_VERIFICATION_INFO: 'verfication-info',
  SMALL_OWNERSHIP_INFO: 'ownership-info',
  SMALL_BADGES: 'badges',
  SMALL_USER_PROFILE: 'user-profile',
  SMALL_REPORT_USER: 'report-user',
  SMALL_ROI_INFO: 'roi-info',
  SMALL_FEE_INFO: 'fee-info',
  SMALL_WINS_INFO: 'wins-info',
  SMALL_LEADERBOARDS_UPDATE_INFO: 'leaderboards-update-info',
  SMALL_SHARE_INVITE_INFO: 'share-invite-info',
  SMALL_PUBLIC_PROFILE_INFO: 'public-profile-info',
  SMALL_RESTRICTED_FUNDS_INFO: 'restricted-funds-info',
  SMALL_ANNOUNCEMENT: 'announcement',
  UPLOAD_DOCUMENT: 'upload-document',
  ORIENTATION: 'orientation',
  SMALL_MESSAGING_JOURNEY: 'messaging-journey',
  SMALL_PWMB_ACCOUNT_CONFIRM_DELETE: 'pwmb-account-confirm-delete',
  AFFILIATIONS: 'affiliations',
  VIDEO: 'video',
  ACCOUNT_ALREADY_EXISTS: 'account-already-exists',
  ACCOUNT_ENABLE_CLASSIC: 'account-enable-classic',
};

export default {
  components: {
    modal,
    announcement,
    affiliationsPopup,
    addFundsCombined,
    addFundsCombinedFooter,
    accountDetailsVerify,
    accountUploadId,
    accountUploadDocument,
    accountDetailsUpdateModal,
    accountLogin,
    accountLoginFooter,
    accountForgotten,
    accountForgottenFooter,
    accountRegister,
    accountRegisterFooter,
    accountRegisterExternal,
    accountUpdateImage,
    attachToHome,
    deposited,
    genericPopup,
    genericSmallPopup,
    offersIndicatorPopup,
    potentialPayouts,
    smallModal,
    exportHistory,
    purchaseModal,
    insightModal,
    research,
    taxInfoNotification,
    twitterTimeline,
    newsFeed,
    marketContractsStatsPopup,
    accountResetPassword,
    orientationInfo,
    accountBadgesList,
    userProfileOverview,
    userProfileOverviewHeader,
    userReport,
    leaderboardsTrophyPyramid,
    messagingJourneyInfo,
    coinbaseProcessOverview,
    accountAlreadyExists,
    accountAlreadyExistsFooter,
    accountEnableClassicPredictit,
    accountEnableClassicPredictitFooter,
  },
  computed: {
    ...mapState('app', ['isTaxNotificationMandatory']),
    ...mapState('popup', [
      'currentPopup', 'currentSmallPopup', 'currentPopupOptions', 'lastTopPosition',
      'tradePopupOptions',
    ]),
    ...mapGetters('app', ['isShutdownModeOn']),
    ...mapGetters('user', ['isUserRestricted']),
    ...mapState('user', ['status']),
    footerHideBodyClass() {
      return this.currentPopupOptions.hideFooter ? 'modal__body--medium modal__footer--hide' : 'modal__body--medium';
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup', 'setCurrentSmallPopup', 'setCurrentPopupWithDelay']),
    ...mapActions('wallet', ['setCurrentDeposit', 'markFirstDepositDone']),
    ...mapActions('user', ['logout']),
    ...mapActions('overlay', { hideOverlay: 'hide' }),
    isCurrentModal(name) {
      return this.currentPopup === name;
    },
    isCurrentSmallModal(name) {
      return this.currentSmallPopup === name;
    },
    closeModal() {
      this.setCurrentPopup();
      this.onClose();
    },
    closeSmallModal() {
      this.setCurrentSmallPopup();
      this.onClose();
    },
    closeModalWithLogout() {
      this.logout();
      this.setCurrentPopup();
      this.onClose();
    },
    closePaymentSuccessModal() {
      this.markFirstDepositDone();
      this.setCurrentPopup();
      this.setCurrentDeposit(null);
      this.onClose();
    },
    closeModalHideOverlay() {
      this.setCurrentPopup();
      this.hideOverlay();
      this.onClose();
    },
    closeUserReportModal() {
      this.setCurrentSmallPopup(MODALS.SMALL_USER_PROFILE);
    },
    onClose() {
      if (this.currentPopupOptions &&
        typeof this.currentPopupOptions.onClose !== 'undefined'
      ) {
        this.currentPopupOptions.onClose.apply(this);
      }
    },
    addFundsClose() {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Deposit',
        action: 'click',
        label: 'Closing/Cancel Deposit Modal',
      });
      this.closeModal();
    },
    paymentSuccessDone() {
      if (this.status.isUCAffilSet === null) {
        this.setCurrentPopupWithDelay({ name: MODALS.AFFILIATIONS });
      } else {
        this.closeModal();
      }
    },
  },
  data() {
    return {
      MODALS,
      gtmAddFunds: {
        virtualPage: '/Account/_DptFrmUsSgnUp',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'Deposit',
          action: 'click',
          label: 'Closing Deposit Modal',
        },
      },
      gtmAccountVerify: {
        virtualPage: '_SgnUpDptIDV',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'ID Verification',
          action: 'click',
          label: 'Closing ID Verification Modal',
        },
      },
      gtmLogin: {
        name: 'login',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'Login',
          action: 'click',
          label: 'Closing Login Modal',
        },
      },
      gtmSignUp: {
        virtualPage: '/Account/SignUp',
        closing: {
          event: 'eventTrackerTrigger',
          category: 'Registration',
          action: 'click',
          label: 'Closing Registration Modal',
        },
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/app/app-modals/app-modals.js